import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import cn from 'classnames';
import './Button.pcss';
export const Button = (props) => {
    const { children, isLoading = false, className, disabled = false } = props;
    return (_jsxs("button", { ...props, disabled: disabled, className: cn('custom-button', { 'custom-button--loading': isLoading }, className), children: [_jsx("div", { className: "custom-button__loader" }), _jsx("div", { className: "custom-button__content", children: children })] }));
};
